import useSWRImmutable from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

const GetJobTypes = (): {
  jobTypes: ILabelValuePair[] | undefined,
  isLoading: boolean,
  isError: boolean,
} => {
  const fetcher = (url: string) => axios.get<{ jobTypes: ILabelValuePair[] }>(url)
    .then((response) => response.data.jobTypes);

  const { data, error } = useSWRImmutable<ILabelValuePair[], AxiosError>('/job/GetJobTypes',
    (url) => fetcher(url));

  return {
    jobTypes: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetJobTypes;
